import { push } from 'connected-react-router'
import { show } from 'redux-modal'
import { rest } from 'services'
import { getShoppingData, getMiniCartData, cleanShoppingData } from 'actions/shoppingData'
import { getAppointments } from 'selectors/getAppointments'
import { getLocationSearch } from 'selectors/getPageLocation'
import DiscontinuedItemInQuoteSubComponent from './components/DiscontinuedItemInQuoteSubComponent'
import NoItemsInQuoteSubComponent from './components/NoItemsInQuoteSubComponent'
import IncompatibleItemsSubcomponent from './components/IncompatibleItemsSubcomponent'
import { getValues as getFormValues, getDateTimeRequestData, getOrderId } from './selectors'
import { getAppointmentConfirmationUrl } from './helpers'
import getActiveVehicle from 'src/selectors/getActiveVehicle'
import {
  USER_PLAN_DROP_OFF,
  GENERIC_MESSAGE_MODAL,
  COMPATIBILITY_STATUS_NON_COMPATIBLE
} from 'constant'
import {
  FIVE_STEPPER,
  THREE_STEPPER
} from 'components/QuickAppointmentPage/constants'
import {
  REMOVE_INACTIVE_TITLE,
  REMOVE_INACTIVE_MESSAGE,
  NO_ITEMS_TITLE,
  NO_ITEMS_MESSAGE,
  REMOVE_INCOMPATIBLE_MESSAGE
} from './constants'

const { api } = rest

export const sendServicesAndDateTime = (
  isFromOnlineAppointment,
  isFromStepper,
  isFromThreeStepper
) => async (dispatch, getState) => {
  const state = getState()
  const { appointmentDate, catalogRefIds, activeVehicleId } = getFormValues(state) || {}
  const { vehicleId } = getActiveVehicle(state)
  const { isTrailer } = getAppointments(state)
  const { myStore, shoppingData } = state
  const onCheckoutPage = getLocationSearch(state).startsWith('?isFromOnlineAppointment=false')

  if (!(myStore && appointmentDate && appointmentDate.time &&
    (!isFromOnlineAppointment || (catalogRefIds && catalogRefIds.length)) &&
    (vehicleId || isTrailer))) {
    return
  }

  const { products, services } = shoppingData.quotedItemAndServices
  const dateTimeRequestData = {
    ...getDateTimeRequestData(appointmentDate),
    isTrailer: isFromThreeStepper ? isTrailer : undefined,
    stepperType: isFromThreeStepper ? THREE_STEPPER : isFromStepper ? FIVE_STEPPER : undefined
  }
  const orderId = getOrderId(shoppingData)

  if (!isFromOnlineAppointment) {
    if (!((products && products.length) || (services && services.length))) {
      const modalOptions = {
        title: NO_ITEMS_TITLE,
        text: NO_ITEMS_MESSAGE,
        SubComponents: NoItemsInQuoteSubComponent
      }

      dispatch(show(GENERIC_MESSAGE_MODAL, modalOptions))
      return
    }

    if (products && products.length) {
      const hasInactiveItems = products.some(product => !product.isActive)

      if (hasInactiveItems) {
        const inactiveItemsModalOptions = {
          title: REMOVE_INACTIVE_TITLE,
          text: REMOVE_INACTIVE_MESSAGE,
          SubComponents: DiscontinuedItemInQuoteSubComponent
        }

        dispatch(show(GENERIC_MESSAGE_MODAL, inactiveItemsModalOptions))
        return
      }

      const hasIncompatibleItems = products.some(({
        compatibilityStatus: { compatibilityType } = {}
      }) => compatibilityType === COMPATIBILITY_STATUS_NON_COMPATIBLE)
      if (hasIncompatibleItems) {
        const incompatibleItemsModalOptions = {
          title: REMOVE_INACTIVE_TITLE,
          text: REMOVE_INCOMPATIBLE_MESSAGE,
          SubComponents: IncompatibleItemsSubcomponent
        }

        dispatch(show(GENERIC_MESSAGE_MODAL, incompatibleItemsModalOptions))
        return
      }
    }
  }

  try {
    if (isFromOnlineAppointment) {
      if (!isTrailer && vehicleId !== activeVehicleId) {
        await api.makeActiveVehicle({ activeVehicleId })
      }

      if (isTrailer) {
        dispatch(cleanShoppingData())
        await dispatch(getMiniCartData())
      }
    }

    if (catalogRefIds && !isFromStepper) {
      await dispatch(getShoppingData(api.addServices, { catalogRefIds }))
    }

    isFromOnlineAppointment ?
      await dispatch(getShoppingData(api.addDateAndTime, dateTimeRequestData)) :
      await dispatch(getShoppingData(api.addAppointmentDetailsToOrder, {
        appointmentDateText: dateTimeRequestData.appointmentDateText,
        appointmentTimeText: dateTimeRequestData.appointmentTimeText,
        userPlan: USER_PLAN_DROP_OFF
      }))

    if (!isFromStepper && !onCheckoutPage) {
      dispatch(push(getAppointmentConfirmationUrl(
        isFromOnlineAppointment,
        myStore.storeId,
        orderId
      )))
    }
  } catch (err) {
    console.error(err)
  }
}
